import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";

function BrandweUse() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [banner, setBanner] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [parentCategory, setParentCategoryGroups] = useState([]);

  const getBrandWeuse = async () => {
    try {
      const response = await privateRequest.get(
        "/BrandWeUse/GetBrandWeUseBystatus"
      );
      setBanner(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/Parentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteBanner = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `BrandWeUse/DeleteBrandWeUse/${_id}`
        );
        getBrandWeuse();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const DeleteBrandbyIndex = async (_id, index) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `BrandWeUse/DeleteBrandbyIndex/${_id}/${index}`
        );
        getBrandWeuse();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  const AddBrandweuse = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("Status", selectedStatus);
      formData.append("PCatID", selectedGroup.value);

      selectedFile.forEach((image, index) => {
        formData.append("BrandLogo", image);
      });

      let response;
      if (selectedItem._id) {
        response = await privateRequest.put(
          `/BrandWeUse/UpdateBrandWeUse/${selectedItem._id}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Brand logos updated successfully!",
        });
      } else {
        response = await privateRequest.post(
          "/BrandWeUse/CreateBrandWeUse",
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Brand logos added successfully!",
        });
      }

      console.log("POST Response:", response);
      getBrandWeuse();
      setShowModal(false);

      setSelectedFile([]);
      setSelectedStatus("");
      setSelectedItem({});
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  const handleFileInputChange = (e) => {
    const selectedImages = Array.from(e.target.files);
    setSelectedFile(selectedImages);
  };
  console.log("selectedfile", selectedFile);
  useEffect(() => {
    getBrandWeuse();
    getParentCategory();
  }, []);

  return (
    <>
      {banner.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Brand Use</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);
                        setSelectedGroup("");
                        setImagePreview("");
                        setSelectedFile([]);
                        setSelectedItem("");
                        setSelectedStatus("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm no-footer text-center"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">BrandsImages</th>
                            <th scope="col">PCName</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {banner?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.BrandLogo &&
                                  item.BrandLogo.map((logo, index) => {
                                    const imageUrl = `${Image_URL}${logo}`;
                                    console.log("Image URL:", imageUrl);
                                    return (
                                      <>
                                        <div
                                          style={{ position: "relative" }}
                                          className="d-inline-block"
                                        >
                                          <img
                                            className="mr-3 img-thumbnail"
                                            style={{
                                              height: "100px",
                                              width: "100px",
                                            }}
                                            key={index}
                                            src={imageUrl}
                                            alt={`Brand Logo ${index + 1}`}
                                            height="100"
                                            width="100"
                                          />
                                          <a
                                            className="btn btn-danger btn-sm btn-icon"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              right: "5px",
                                            }}
                                            href="javascript:void(0)"
                                            onClick={() =>
                                              DeleteBrandbyIndex(
                                                item._id,
                                                index
                                              )
                                            }
                                          >
                                            <i className="fa fa-trash"></i>
                                          </a>
                                        </div>
                                      </>
                                    );
                                  })}
                              </td>

                              <td className="align-center">
                                {item?.PCatID?.PCName}
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    item?.Status.toString() === "true"
                                      ? "badge-primary"
                                      : "badge-danger"
                                  }`}
                                >
                                  {item?.Status.toString() === "true"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      let ids = {
                                        label: item?.PCatID?.PCName,
                                        value: item?.PCatID?._id,
                                      };
                                      setSelectedItem(item);
                                      setSelectedFile(null);
                                      setSelectedGroup(ids);
                                      setSelectedStatus(
                                        item.Status ? "1" : "0"
                                      );
                                      setSelectedFile(item.BrandLogo);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteBanner(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Brand Use
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddBrandweuse}>
                <div className="row">
                  <div className="col-lg-8">
                    <div className="form-group">
                      <label className="mb-0">Images</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        multiple
                        onChange={handleFileInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Select P Cat</label>
                      <Select
                        isClearable
                        options={parentCategory.map((group) => ({
                          value: group._id,
                          label: group.PCName,
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedGroup(selectedOption)
                        }
                        value={selectedGroup}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  {imagePreview && (
                    <div className="col-lg-12">
                      <img
                        width="80"
                        height="50"
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  )}
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItem._id ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default BrandweUse;
